/* eslint-disable camelcase, @typescript-eslint/no-unsafe-return, no-nested-ternary, no-unneeded-ternary */
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Box, CircularProgress } from '@mui/material';
import PlaceOrdersList from './PlaceOrdersList';
import OrdersService from '../../../../../services/ordersService';
import Permissions from '../../../../Layout/AdminSidebar/Permissions';
import { getEnvSettings } from '../../../../../config/environmentSettings';
import { getWidgetColumns } from '../../../../../redux/selectors/custodySelectors';
import { useServiceFetchApis } from '../../../../../shared/hooks/useServiceFetchApis';
import { getSelectedClientInputValue } from '../../../../../redux/selectors/clientSearchSelectors';
import DLTFTableFilters from '@shared/components/filters/DLTFTableFilters';
import { FIAT_CURRENCIES } from '@shared/constants/FiatOptions';
import { getExchanges } from '../../../../../redux/selectors/selectors';
import { getTradingCurrencies } from '../../../../../redux/selectors/currenciesSelectors';
import { MASTER_TENANT_ORDERS_URL_OPTIONS_SET_UPDATE, } from '../../../../../redux/actionTypes/masterTenantActionTypes';
export const UrlOptionsUpdate = (urlOptionsHedgeOrders) => ({
    type: MASTER_TENANT_ORDERS_URL_OPTIONS_SET_UPDATE,
    urlOptionsHedgeOrders,
});
function getFilters(currencies, exchanges) {
    const status = {
        name: 'status',
        label: 'Status',
        multi: true,
        values: [
            { value: 'ToCancel', label: 'To Cancel' },
            { value: 'Open', label: 'Open' },
            { value: 'Filled', label: 'Filled' },
            { value: 'Rejected', label: 'Rejected' },
            { value: 'Canceled', label: 'Canceled' },
            { value: 'CanceledPartiallyFilled', label: 'Canceled Partially Filled' },
        ],
    };
    const base = {
        name: 'base',
        label: 'Base',
        multi: true,
        values: currencies.map((c) => ({ value: c.code, label: c.code.toUpperCase() })),
    };
    const exchange_code = {
        name: 'exchange_code',
        label: 'Exchange',
        values: exchanges.map((e) => ({ value: e.code, label: e.name })),
    };
    const action_type = {
        name: 'action_type',
        label: 'Action',
        values: [
            { value: 'Buy', label: 'Buy' },
            { value: 'Sell', label: 'Sell' },
            { value: null, label: 'All' },
        ],
    };
    const order_type = {
        name: 'order_type',
        label: 'Order Type',
        multi: true,
        defaultValue: ['limit', 'market'],
        values: [
            { value: 'limit', label: 'Limit' },
            { value: 'market', label: 'Market' },
            { value: 'rfq_market', label: 'RFQ Market' },
            { value: 'rfq_limit', label: 'RFQ Limit' },
        ],
    };
    const from = {
        name: 'from',
        label: 'From',
        type: 'dateFrom',
    };
    const to = {
        name: 'to',
        label: 'To',
        type: 'dateTo',
    };
    const amount_from = {
        name: 'amount_from',
        label: 'Amount From',
        type: 'number',
    };
    const amount_to = {
        name: 'amount_to',
        label: 'Amount To',
        type: 'number',
    };
    const quote = {
        name: 'quote',
        label: 'Quote',
        values: FIAT_CURRENCIES,
    };
    return [status, exchange_code, base, quote, order_type, action_type, from, to, amount_from, amount_to];
}
const MainContainer = ({ columns, features, widgetKey, clientInfo, urlOptionsHedgeOrders, exchanges, currencies, UrlOptionsUpdateDispatch, }) => {
    const [page, setPage] = useState(0);
    const [total, setTotal] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(0);
    const [orders, setOrders] = useState([]);
    const [service, setService] = useState(null);
    const [isReady, setIsReady] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const sortDirection = 'desc';
    const sortBy = 'created';
    const { data } = useServiceFetchApis(service, urlOptionsHedgeOrders, 5000, !isReady);
    const [filtersOptions, setFiltersOptions] = useState([]);
    const [filters, setFilters] = useState();
    const handleFiltersUpdate = (data) => {
        setPage(0);
        setFilters(data);
    };
    useEffect(() => {
        if (filters && rowsPerPage) {
            setIsReady(true);
        }
    }, [filters, page, rowsPerPage]);
    useEffect(() => {
        if (!isReady)
            return;
        const tableParams = {
            limit: rowsPerPage,
            sortBy: sortBy,
            sortDirection: sortDirection,
            page: page,
        };
        function toStartOfDayISO(date) {
            return new Date(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0).toISOString();
        }
        function toEndOfDayISO(date) {
            return new Date(date.getFullYear(), date.getMonth(), date.getDate(), 23, 59, 59).toISOString();
        }
        const formattedFilters = Object.assign(Object.assign({}, filters), { from: (filters === null || filters === void 0 ? void 0 : filters.from) ? toStartOfDayISO(new Date(filters.from)) : undefined, to: (filters === null || filters === void 0 ? void 0 : filters.to) ? toEndOfDayISO(new Date(filters.to)) : undefined });
        function toQueryStringWithPipes(params) {
            return ('?' +
                Object.entries(params)
                    .map(([key, value]) => {
                    if (Array.isArray(value)) {
                        return `${encodeURIComponent(key)}=${value.map((v) => encodeURIComponent(v)).join('|')}`;
                    }
                    else if (value != null) {
                        return `${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
                    }
                    return '';
                })
                    .filter(Boolean)
                    .join('&'));
        }
        setIsLoading(true);
        UrlOptionsUpdateDispatch(toQueryStringWithPipes(Object.assign(Object.assign({}, formattedFilters), tableParams)));
    }, [filters, page, rowsPerPage]);
    useEffect(() => {
        if (exchanges && currencies) {
            setFiltersOptions(getFilters(currencies, exchanges));
        }
    }, [exchanges, currencies]);
    useEffect(() => {
        let isCancelled = false;
        if (!isCancelled) {
            const serviceInstance = new OrdersService({
                baseURL: getEnvSettings().adminApiUrl,
                url: '/trade/autohedger/orders',
                method: 'get',
            }, '/trade/autohedger/orders');
            setService(serviceInstance);
        }
        return () => {
            isCancelled = true;
        };
    }, []);
    useEffect(() => {
        if (data) {
            setIsLoading(false);
            setOrders(data.records);
            setTotal(data.total);
        }
    }, [data]);
    if (!clientInfo) {
        return (React.createElement(Box, { display: 'flex', justifyContent: 'center', p: 4, role: 'slider' },
            React.createElement(CircularProgress, { size: '33px' })));
    }
    return (React.createElement("div", { className: 'content-body', role: 'main' },
        React.createElement(Permissions, { features: features, permissions: ['order.read'] },
            React.createElement(Box, null,
                React.createElement(Box, { p: 1 },
                    React.createElement(DLTFTableFilters, { fields: filtersOptions, onChange: (data) => handleFiltersUpdate(data), onReset: () => { } })),
                React.createElement("div", { role: 'table', className: 'card-body' },
                    React.createElement(PlaceOrdersList, { dataLoading: isLoading, page: page, total: total, orders: orders, setPage: setPage, columns: columns, widgetKey: widgetKey, rowsPerPage: rowsPerPage, setRowsPerPage: setRowsPerPage }))))));
};
const mapStateToProps = (state, ownProps) => ({
    widgetKey: ownProps.widgetKey,
    features: state.client.features,
    clientInfo: state.client.clientInfo,
    selectedClient: getSelectedClientInputValue(state),
    columns: getWidgetColumns(state, ownProps.widgetKey),
    urlOptionsHedgeOrders: state.masterTenant.urlOptionsHedgeOrders,
    exchanges: getExchanges(state),
    currencies: getTradingCurrencies(state),
});
const mapDispatchToProps = (dispatch) => ({
    UrlOptionsUpdateDispatch: (url) => dispatch(UrlOptionsUpdate(url)),
    initialValue: '',
});
export default connect(mapStateToProps, mapDispatchToProps)(MainContainer);
